import { Theme, List, ListItem, ListItemAvatar, Avatar, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { IRiderBest } from "../../models/IRider";
import CircuitServiceInstance from "../../services/CircuitService";
import DateHelperInstance from "../../services/DateHelper";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            // maxWidth: 345,
            width: '100%',
            paddingTop: theme.spacing(10),
        },
        media: {
            height: 140,
        },
        fixedHeight: {
            maxHeight: 640,
            overflow: 'auto',
        },
        content: {
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
        },
        container: {
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4),
        },
        appBarSpacer: theme.mixins.toolbar,
    }));

interface ICircuitBestsProps {
    circuitId: string;
    eventType: string;
}

interface IBestRiderCardProps {
    rider: IRiderBest;
}

export function BestRiderCard(props: IBestRiderCardProps) {
    const { rider } = props;
    return (
        <ListItem alignItems="flex-start">
            <ListItemAvatar>
                <Avatar alt={rider.riderName} src={rider.pictureUrl} />
            </ListItemAvatar>
            <div>
                <Typography variant="body1">
                    {rider.riderName}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    {DateHelperInstance.millisToMinutesSecondsAndMilliseconds(rider.timeMs)}
                </Typography>
            </div>
        </ListItem>
    );
}

export function CircuitBests(props: ICircuitBestsProps) {
    const [bestRiders, setBestRiders] = useState<IRiderBest[]>([]);
    const classes = useStyles();

    useEffect(() => {
        const source = axios.CancelToken.source();
        CircuitServiceInstance.getBests(props.circuitId, props.eventType, source.token).then((bestRiders: IRiderBest[]) => {
            setBestRiders(bestRiders);
        }).catch((error) => {
            if (!axios.isCancel(error)) {
                console.error('Failed to fetch circuit bests:', error);
            }
        });
        return () => {
            source.cancel();
        };
    }, [props.circuitId, props.eventType]);

    return (
        <List className={classes.root} >
            {
                bestRiders.map(rider => {
                    return <BestRiderCard key={rider.riderName} rider={rider} />
                })
            }
        </List>
    );
}